// extracted by mini-css-extract-plugin
export default {"btnCancel":"SubmitButton_btnCancel__r0kB7","btnUpdate":"SubmitButton_btnUpdate__W3OLO"};